/*! Twire stripe - MIT license  */
export default {

	// amount
	// Leave as null which assumes you caluclate the amount server-side, otherwise set an amount
	// (the latter useful for online donations, for exmaple); set to 0 (best to ensure server-side) 
	// for SetupIntent (i.e. a card for later use only, no payment)
	amount:					null,
	stripe:				 	null,
	elements:			   	null,
	$form:				  	null,
	cardErrors:			 	{},
	generalError:		   	'An error occurred processing the payment',
	serverError:			'A server error occurred; please contact us to check your payment status',
	onGeneralError:		 	($form, message) => { alert(message); },
	onServerError:		  	($form, message) => { alert(message); },
	onPaymentStart:		 	($form) => {},
	onSuccess: 				($form, paymentIntent, mode) => {},
	paymentMethodElement:   null,
	returnURL: 				null,
	cardClassNames: {

		number: 'card-number',
		expiry: 'card-expiry',
		cvc:	'card-cvc'

	},
	cardBillingFormNames: {

		name:   'name',
		email:  'email',
		phone:  'phone',

		address: {

			line1:	  	'address-line-1',
			line2:	  	'address-line-2',
			town:	   	'town',
			county:	 	'county',
			postcode:   'postcode',
			country:	'country'

		}
	},
	init: function($form, apiKey, elementsConfig, style, locale = 'en', apiVersion = '2024-06-20') {

		var _self		   = this;
		_self.$form		 	= $form;
		_self.cardErrors	= require('../json/twire.stripe-card-errors-' + locale + '.json');
		_self.stripe		= Stripe(apiKey, {

			apiVersion: apiVersion
			
		});

		_self.elements	  			= _self.stripe.elements(elementsConfig);
		_self.paymentMethodElement 	= _self.elements.create('cardNumber', { style: style });

		_self.paymentMethodElement.mount('.' + _self.cardClassNames.number);

		_self.elements.create('cardExpiry', { style: style }).mount('.' + _self.cardClassNames.expiry);
		_self.elements.create('cardCvc',	{ style: style }).mount('.' + _self.cardClassNames.cvc);

	},

	processPayment: function(path, metaData, customer = '', save = false) {

		var _self	= this;
		_self.path 	= path;

		_self.onPaymentStart(_self.$form);
		
		$.ajax({

			type: 'POST',
			url: _self.path,
			data: _self.$form.serialize() + '&' + $.param({

				twire: JSON.stringify({

					email:		_self.$form.find('[name="' + _self.cardBillingFormNames.email + '"]').val(),
					amount:	   	_self.amount,
					metaData:	metaData,
					customer:	customer,
					save:		save ? 1 : 0

				})
			})
		}).done(function(response) {
			
			if (response.data && response.data == 'custom-message') {

				_self.onServerError(_self.$form, response.message);

				return;

			}

			// Determine which Stripe function to use based on the mode
			var confirmMethod = (response.data.mode === 'setup') ? 'confirmCardSetup' : 'confirmCardPayment';

			// Using your mapping here instead of hard-coding
			_self.stripe[confirmMethod](response.data.client_secret, {

				payment_method: {

					card: _self.paymentMethodElement,
					billing_details: {

						name:  _self.$form.find('[name="' + _self.cardBillingFormNames.name  + '"]').val(),
						email: _self.$form.find('[name="' + _self.cardBillingFormNames.email + '"]').val(),
						phone: _self.$form.find('[name="' + _self.cardBillingFormNames.phone + '"]').val(),

						address: {

							line1:	   		_self.$form.find('[name="' + _self.cardBillingFormNames.address.line1	+ '"]').val(),
							line2:	   		_self.$form.find('[name="' + _self.cardBillingFormNames.address.line2	+ '"]').val(),
							city:			_self.$form.find('[name="' + _self.cardBillingFormNames.address.town	 + '"]').val(),
							state:	   		_self.$form.find('[name="' + _self.cardBillingFormNames.address.county   + '"]').val(),
							postal_code:	_self.$form.find('[name="' + _self.cardBillingFormNames.address.postcode + '"]').val(),
							country:	 	_self.$form.find('[name="' + _self.cardBillingFormNames.address.country  + '"]').val()

						}
					}
				},
				return_url: _self.returnURL

			}, { 

				redirect: 'if_required' // Only redirect if you absolutely have to

			}).then(function(result) {

				if (result.error) {

					_self.onGeneralError(_self.$form, _self.getError(result.error.code));

				} else {
					
					// result will contain either .paymentIntent or .setupIntent
					var intent = (response.data.mode === 'setup') ? result.setupIntent : result.paymentIntent;

					if (intent && intent.status == 'succeeded') {

						_self.onSuccess(_self.$form, intent.id, response.data.mode);

					}
				}

			});

		}).fail(function(jqXHR) {

			_self.handleFail(jqXHR);

		});
	},

	handleFail: function(jqXHR) {

		var _self = this;

		console.log('twire.stripe.handleFail:');
		console.log(jqXHR);

		if (jqXHR.responseJSON && jqXHR.responseJSON.data && jqXHR.responseJSON.data == 'custom-message') {

			_self.onGeneralError(_self.$form, jqXHR.responseJSON.message);

		} else {

			_self.onServerError(_self.$form, _self.serverError);

		}
	},

	getError: function(code) {

		var _self = this;

		return _self.cardErrors[code] || _self.generalError;

	}

};